import Constants from '@/constants/index';
import { COUNTRY_LANGUAGE, LOCALE_ALIAS, LOCALE_SETTINGS } from '@/core/i18n/constants';
import { Url } from '@/core/helpers';
import { CulturePluginOptions } from '@/core/i18n/interfaces';

export const CULTURE_CONFIG: CulturePluginOptions = {
    id: 'checkout',
    defaultLang: Constants.i18n.DEFAULT_LANG,
    localeSettings: LOCALE_SETTINGS,
    localeAlias: LOCALE_ALIAS,
    countryLanguage: COUNTRY_LANGUAGE,
    i18nextOptions: {
        lng: Constants.i18n.LOCALIZE_OPTIONS.culture,
        fallbackLng: Constants.i18n.LOCALIZE_OPTIONS.culture,
        ns: ['common', 'event-id', 'errors', 'countries', 'accessibility'],
        backend: {
            loadPath: Url.join(
                process.env?.BASE_URL || '',
                Constants.i18n.LOCALIZE_OPTIONS.path
            ),
            queryStringParams: { v: process.env.VUE_APP_CACHE_VERSION }
        }
    }
};
